import { LocaleUtils } from "@grandvisionhq/utils";
const getLocaleSwitcherData = (availableLocales, populateLink) => {
  return availableLocales.map((option) => {
    return {
      label: `${option.buttonCaption}`,
      link: populateLink ? { type: "internal", href: option.path } : void 0,
      parameters: {
        action: () => {
          LocaleUtils.setLocaleToCookie(option.locale.replace("_", "-"));
          window && window.location.assign(LocaleUtils.getLocaleSwitchPath(option.path));
        }
      }
    };
  });
};
export {
  getLocaleSwitcherData
};
//# sourceMappingURL=get-locale-switcher-data.js.map
